import { render } from "./Matriculas.vue?vue&type=template&id=933d1d04&scoped=true"
import script from "./Matriculas.vue?vue&type=script&lang=js"
export * from "./Matriculas.vue?vue&type=script&lang=js"

import "./Matriculas.vue?vue&type=style&index=0&id=933d1d04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-933d1d04"]])

export default __exports__